module.exports = __webpack_public_path__ + "Print.jpg?67831b107e9b9a9152136e8704cb2638";


//////////////////
// WEBPACK FOOTER
// ./static/images/Print.jpg
// module id = 28
// module chunks = 0 1